const OWNER_PATH_SEGMENT = {
  PROPOSAL: { base: "proposals", surface: "writing" },
  MISC_ANALYSIS: { base: "misc-analysis", surface: "proposal-writing" },
};

export const buildWritingEditorUrl = (owner, documentId) => {
  if (!owner?.ownerType || owner?.ownerId == null || !documentId) {
    return null;
  }
  const segment = OWNER_PATH_SEGMENT[owner.ownerType];
  if (!segment) {
    return null;
  }
  return `/${segment.base}/view/${owner.ownerId}/${segment.surface}/view/${documentId}`;
};
